"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _isNil = _interopRequireDefault(require("lodash/isNil"));

var _InputField = _interopRequireDefault(require("../../atoms/InputField"));

var _Flex = _interopRequireDefault(require("../Flex"));

var _useTranslations = _interopRequireDefault(require("../../utils/useTranslations"));

var _Input = _interopRequireDefault(require("./Input"));

var _schema = _interopRequireDefault(require("./schema"));

var _ShowPasswordButton = _interopRequireDefault(require("./ShowPasswordButton"));

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    keys.push.apply(keys, Object.getOwnPropertySymbols(object));
  }

  if (enumerableOnly) keys = keys.filter(function (sym) {
    return Object.getOwnPropertyDescriptor(object, sym).enumerable;
  });
  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function PasswordField(_ref, ref) {
  var hideLabel = _ref.hideLabel,
      initialPasswordVisible = _ref.initialPasswordVisible,
      disabled = _ref.disabled,
      props = _objectWithoutProperties(_ref, ["hideLabel", "initialPasswordVisible", "disabled"]);

  var _useState = (0, _react.useState)(!!initialPasswordVisible),
      _useState2 = _slicedToArray(_useState, 2),
      showPassword = _useState2[0],
      setShowPassword = _useState2[1];

  var translate = (0, _useTranslations.default)();
  var inputRef = (0, _react.useRef)(null);
  var handleClick = (0, _react.useCallback)(function () {
    setShowPassword(!showPassword);
  }, [showPassword, setShowPassword]);
  var inputType = showPassword ? 'text' : 'password'; // Moving cursor to the end after re-rendering input because of `type`

  (0, _react.useEffect)(function () {
    if (!(0, _isNil.default)(inputRef) && !(0, _isNil.default)(inputRef.current)) {
      inputRef.current.selectionStart = inputRef.current.value.length;
      inputRef.current.selectionEnd = inputRef.current.value.length;
    }
  }, [inputType]);
  var setInputRef = (0, _react.useCallback)(function (propRef) {
    return function (element) {
      inputRef.current = element; // eslint-disable-next-line no-param-reassign

      propRef.current = element;
    };
  }, []);
  return _react.default.createElement(_InputField.default, _extends({}, props, {
    disabled: disabled,
    label: translate(undefined, 'passwordField.password'),
    hideLabel: hideLabel,
    ref: ref,
    secondaryElement: // eslint-disable-next-line react/jsx-wrap-multilines
    _react.default.createElement(_ShowPasswordButton.default, {
      disabled: disabled,
      showPassword: showPassword,
      onClick: disabled ? undefined : handleClick
    })
  }), function (p) {
    return _react.default.createElement(_Flex.default, {
      flexDirection: "row",
      flex: 1
    }, _react.default.createElement(_Input.default, _extends({}, p, {
      ref: setInputRef(p.ref),
      role: "password",
      passwordVisible: showPassword,
      hideLabel: hideLabel,
      type: inputType,
      "data-testid": "password-input"
    })));
  });
}

var PasswordFieldWithRef = (0, _react.forwardRef)(PasswordField);
PasswordFieldWithRef.displayName = 'TextField';
PasswordFieldWithRef.propTypes = _objectSpread({}, _schema.default.propTypes, {
  icon: _propTypes.default.elementType
});
var _default = PasswordFieldWithRef;
exports.default = _default;